import React, { useState } from 'react'
import './confirm-password-reset-form.css'
import { Card, Button, Form, Alert } from 'react-bootstrap'
import HeaderLogo from '../../../assets/navbar/roiquant-600x200px-white-01.png';

/**
 * ConfirmPasswordResetForm Component
 * 
 * Displays a form for users to confirm their password reset after receiving a reset email.
 * Allows users to enter and confirm their new password with real-time validation feedback.
 * 
 * @param {Object} props - Component props
 * @param {string} props.response - Response message/alert to display to the user
 * @param {Object} props.pwds - Object containing newPwd and confirmPwd fields
 * @param {Function} props.setPwds - State setter for password object
 * @param {Function} props.handleCompletePwdChange - Callback to submit password change
 * @param {Function} props.checkPwdLength - Validates password is at least 8 characters
 * @param {Function} props.checkPwdSymbol - Validates password contains a symbol
 * @param {Function} props.checkPwdUppercase - Validates password contains uppercase letter
 * @param {Function} props.checkPwdLowercase - Validates password contains lowercase letter
 * @param {Function} props.checkPwdNum - Validates password contains a number
 * @param {Function} props.checkPwdMatch - Validates passwords match
 * @param {Function} props.measurePwdLength - Returns password length
 * @returns {JSX.Element} Password reset confirmation form
 */

function ConfirmPasswordResetForm(props) {

  // Handle form submission (prevents default behavior)
  const handleSubmit = event => {
    event.preventDefault();
  }

  // Track visibility state of new password field
  const [passwordShown, setPasswordShown] = useState(false);

  // Toggle visibility of new password input field
  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };

  // Track visibility state of confirm password field
  const [cpasswordShown, setcPasswordShown] = useState(false);

  // Toggle visibility of confirm password input field
  const togglecPassword = () => {
    setcPasswordShown(!cpasswordShown);
  };

  return (
    <div id="resetpasswordcontent">

      <div className="resetpasswordtop">
        <a href="https://www.roiquant.com/" target="_blank" rel="noopener noreferrer">
          <img src={HeaderLogo} alt="roiquant" width="180px" height="60px" className="roiquantlogo" />
        </a>
      </div>

      <div>{props.response}</div>

      <div id="resetpasswordform">
        <Card className="resetpasswordcard">
          <div className="resetpasswordheader">
            <h3>Password reset confirmation</h3>
          </div>

          <div className="createaccnote">
            <p>For security reasons, please confirm your password reset.</p>
          </div>

          <Form className="resetpasswordformbox" onSubmit={handleSubmit}>
            {/* New password input with show/hide toggle */}
            <Form.Group className="inputgroup">
              <Form.Control className="inputbox" type={passwordShown ? "text" : "password"} name="newpassword" placeholder="Enter new password"
                onChange={(e) => { props.setPwds(Object.assign({}, props.pwds, { newPwd: e.target.value })) }}
              />
              {/* Toggle button to show/hide password */}
              <a href="#" className='showpassword' onClick={togglePassword}>{passwordShown ? "Hide" : "Show"} password</a>
            </Form.Group>

            {/* Confirm password input with show/hide toggle */}
            <Form.Group className="inputgroup">
              <Form.Control className="inputbox" type={cpasswordShown ? "text" : "password"} name="confirmpassword" placeholder="Confirm new password"
                onChange={(e) => { props.setPwds(Object.assign({}, props.pwds, { confirmPwd: e.target.value })) }}
              />
              {/* Toggle button to show/hide confirm password */}
              <a href="#" className='showcpassword' onClick={togglecPassword}>{cpasswordShown ? "Hide" : "Show"} password</a>
            </Form.Group>

            {/* Password validation feedback section - displays real-time validation status */}
            <div id="validation" style={{ width: "100%", display: "flex", flexDirection: "row" }}>
              {/* Left column: Character count, symbols, and uppercase validation */}
              <Form.Group className="inputgroup" controlId="formNewPassword"
                style={{ width: "50%", paddingRight: "1.5%" }}
              >
                <div id="checksField">
                  <p id="char" style={{ color: props.measurePwdLength(props.pwds.newPwd) == 0 ? "grey" : props.checkPwdLength(props.pwds.newPwd) ? "green" : "red" }}>At least 8 characters or as long as possible</p>

                  <p id="char" style={{ color: props.measurePwdLength(props.pwds.newPwd) == 0 ? "grey" : props.checkPwdSymbol(props.pwds.newPwd) ? "green" : "red" }}>Include at least 1 symbol character </p>

                  <p id="char" style={{ color: props.measurePwdLength(props.pwds.newPwd) == 0 ? "grey" : props.checkPwdUppercase(props.pwds.newPwd) ? "green" : "red" }}>At least 1 uppercase letter</p>
                </div>

              </Form.Group>

              {/* Right column: Numbers, lowercase, and password match validation */}
              <Form.Group className="inputgroup"
                style={{ width: "50%", paddingLeft: "1.5%" }} >
                <div id="checksField">
                  <p id="char" style={{ color: props.measurePwdLength(props.pwds.newPwd) == 0 ? "grey" : props.checkPwdNum(props.pwds.newPwd) ? "green" : "red" }}>Include at least 1 number</p>

                  <p id="char" style={{ color: props.measurePwdLength(props.pwds.newPwd) == 0 ? "grey" : props.checkPwdLowercase(props.pwds.newPwd) ? "green" : "red" }}>At least 1 lowercase letter</p>

                  <p id="char" style={{ color: props.measurePwdLength(props.pwds.newPwd) == 0 ? "grey" : props.checkPwdMatch(props.pwds.newPwd, props.pwds.confirmPwd) ? "green" : "red" }}>Both passwords must match </p>
                </div>

              </Form.Group>

            </div>

            {/* Submit button to confirm password reset */}
            <div style={{ textAlign: "center" }}>
              <Button type="submit" className="resetpasswordbtn glintanimation" onClick={() => { props.handleCompletePwdChange(props.pwds, props.token, props.tokenId, props.user) }}>
                <span>Confirm password reset</span>
              </Button>
            </div>

          </Form>

          <div className="loginnote">
            <span>
              Forgot your new password? <br></br><a href="/reset-password">Try resetting your password again</a>
            </span>
          </div>

        </Card>
      </div>
    </div>
  )
}

export default ConfirmPasswordResetForm